// Russian -> Latin transliteration table.
// Soft/hard signs (ъ, ь) drop silently; ы -> y; ё -> yo; щ -> sch.
const TRANSLIT_MAP = {
  а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'yo',
  ж: 'zh', з: 'z', и: 'i', й: 'y', к: 'k', л: 'l', м: 'm',
  н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u',
  ф: 'f', х: 'h', ц: 'ts', ч: 'ch', ш: 'sh', щ: 'sch',
  ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya',
};

// Characters allowed verbatim after mapping (url-safe subset).
const SAFE_CHAR = /[a-z0-9-]/;

/**
 * Transliterate Cyrillic text into a url-safe lowercase latin slug.
 * Strips everything that is neither a mapped cyrillic char nor a safe ascii char.
 *
 * @param {string} text raw input.
 * @returns {string} transliterated lowercase slug.
 */
export function translit(text) {
  if (typeof text !== 'string' || text.length === 0) return '';
  const lower = text.toLowerCase();
  let out = '';
  for (const ch of lower) {
    if (Object.prototype.hasOwnProperty.call(TRANSLIT_MAP, ch)) {
      out += TRANSLIT_MAP[ch];
    } else if (SAFE_CHAR.test(ch)) {
      out += ch;
    }
    // everything else is dropped
  }
  return out;
}

/**
 * Build a room-slug portion of the URL — trimmed and length-capped.
 *
 * @param {string} name raw room name.
 * @param {number} [maxLen=40] max slug length.
 */
export function buildRoomSlug(name, maxLen = 40) {
  return translit((name || '').trim()).slice(0, maxLen);
}
